// Glossaire des termes métier CEE
export interface GlossaryTerm {
  term: string;
  shortDefinition: string;
  longDefinition?: string;
  category: 'cee' | 'commercial' | 'administratif' | 'technique';
}

export const GLOSSARY_TERMS: Record<string, GlossaryTerm> = {
  cee: {
    term: 'CEE',
    shortDefinition: 'Certificat d\'Économie d\'Énergie',
    longDefinition: 'Dispositif d\'aide financière qui oblige les fournisseurs d\'énergie à promouvoir les économies d\'énergie. Les travaux éligibles génèrent des primes versées aux clients.',
    category: 'cee',
  },
  fiche_cee: {
    term: 'Fiche CEE',
    shortDefinition: 'Document officiel décrivant une opération d\'économie d\'énergie',
    longDefinition: 'Document standardisé publié par le ministère qui définit les conditions d\'éligibilité, les calculs de primes et les justificatifs requis pour chaque type de travaux.',
    category: 'cee',
  },
  lead: {
    term: 'Lead',
    shortDefinition: 'Prospect commercial potentiel',
    longDefinition: 'Contact ou entreprise identifié comme potentiellement intéressé par vos solutions. Un lead devient client après signature d\'un contrat.',
    category: 'commercial',
  },
  dossier: {
    term: 'Dossier',
    shortDefinition: 'Dossier administratif pour obtenir la prime CEE',
    longDefinition: 'Ensemble des documents justificatifs nécessaires pour valider une opération CEE et obtenir le versement de la prime. Comprend devis, factures, attestations, etc.',
    category: 'administratif',
  },
  eligibilite: {
    term: 'Éligibilité',
    shortDefinition: 'Vérification que le client peut bénéficier de l\'aide',
    longDefinition: 'Analyse des critères techniques et administratifs permettant de déterminer si une opération peut bénéficier des primes CEE : type de bâtiment, date de construction, nature des travaux, etc.',
    category: 'cee',
  },
  prime: {
    term: 'Prime',
    shortDefinition: 'Montant financier versé au client',
    longDefinition: 'Aide financière versée au bénéficiaire des travaux en contrepartie des économies d\'énergie réalisées. Calculée en fonction des kWh cumac générés.',
    category: 'cee',
  },
  kwh_cumac: {
    term: 'kWh cumac',
    shortDefinition: 'Unité de mesure de l\'économie d\'énergie',
    longDefinition: 'Kilowattheure cumulé actualisé sur la durée de vie de l\'équipement. C\'est l\'unité de mesure des CEE qui détermine le montant de la prime.',
    category: 'technique',
  },
  qualification: {
    term: 'Qualification',
    shortDefinition: 'Collecte des informations clés sur un prospect',
    longDefinition: 'Étape commerciale consistant à recueillir les informations essentielles sur un lead : coordonnées, type de bâtiment, besoins, budget, etc.',
    category: 'commercial',
  },
  produit: {
    term: 'Produit',
    shortDefinition: 'Solution commerciale proposée au client',
    longDefinition: 'Offre commerciale packagée comprenant les travaux, les équipements et les services associés pour réaliser une opération d\'économie d\'énergie.',
    category: 'commercial',
  },
  commission: {
    term: 'Commission',
    shortDefinition: 'Rémunération sur la vente réalisée',
    longDefinition: 'Part du chiffre d\'affaires ou de la marge reversée au commercial ou au manager ayant réalisé la vente.',
    category: 'commercial',
  },
  secteur: {
    term: 'Secteur',
    shortDefinition: 'Catégorie d\'activité du client',
    longDefinition: 'Classification du client selon son domaine d\'activité : tertiaire, industrie, résidentiel, agriculture, transport, etc. Détermine les fiches CEE applicables.',
    category: 'administratif',
  },
};

// Fonction pour obtenir une définition par terme
export function getTermDefinition(termKey: string): GlossaryTerm | undefined {
  return GLOSSARY_TERMS[termKey.toLowerCase().replace(/\s+/g, '_')];
}

// Liste des termes par catégorie
export function getTermsByCategory(category: GlossaryTerm['category']): GlossaryTerm[] {
  return Object.values(GLOSSARY_TERMS).filter(t => t.category === category);
}
